import { render, staticRenderFns } from "./TermRestrictedChoice.vue?vue&type=template&id=6a7e91d7"
import script from "./TermRestrictedChoice.vue?vue&type=script&lang=js"
export * from "./TermRestrictedChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports